import { type api, isTruthy } from 'common';

import { getOperationLabel } from './constants';
import { NodeHandleNameOverflowVariant } from '../../types';

export function getNodeOutputHandle(
  condition: api.FlowDefinition.Conditional.ConditionalCondition
) {
  return {
    type: 'source' as const,
    id: condition.id,
    handleName: getNodeOutputHandleName(condition),
    nameWrapVariant: NodeHandleNameOverflowVariant.Ellipsis,
  };
}

function getNodeOutputHandleName(condition: api.FlowDefinition.Conditional.ConditionalCondition) {
  if (isTruthy(condition.label?.trim())) {
    return condition.label;
  }
  const operationLabel = getOperationLabel(condition);
  if ('value' in condition) {
    return `${condition.inputValue} ${operationLabel} ${condition.value}`;
  }
  if ('minValue' in condition && 'maxValue' in condition) {
    return `${condition.inputValue} ${operationLabel} ${condition.minValue} to ${condition.maxValue}`;
  }
  return `${condition.inputValue} ${operationLabel}`;
}
